// 1. Import the Bootstrap component
import { Modal } from 'bootstrap';

// 2. Export the component
export default Modal;
